import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      100: "#E9E3FF",
      200: "#01509E",
      300: "#01509E",
      400: "#7551FF",
      500: "#01509E",
      600: "#3311DB",
      700: "#02044A",
      800: "#190793",
      900: "#11047A",
    },
    brandScheme: {
      100: "#E9E3FF",
      200: "#7551FF",
      300: "#7551FF",
      400: "#7551FF",
      500: "#01509E",
      600: "#3311DB",
      700: "#02044A",
      800: "#190793",
      900: "#02044A",
    },
    brandTabs: {
      100: "#E9E3FF",
      200: "#01509E",
      300: "#01509E",
      400: "#01509E",
      500: "#01509E",
      600: "#3311DB",
      700: "#02044A",
      800: "#190793",
      900: "#02044A",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      300: "#eb7b74",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      400: "#fde04ce8",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
      600: "#20a574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      50: "#ededed",
      100: "#FAFCFE",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
    text: {
      100: "#435580",
      200: "#38476B",
    },
    navText: {
      100: "#435580",
    },
    error: {
      100: "#E6533C",
    },
    cta: {
      100: "#01509E",
    },
    activeSideBarBg: {
      100: "#1D284D",
    },
    borderColor: "#C4CCE0",
    white: "#FFFFFF",
    hoverBg: "#F2F4FA",
    iconDark: "#4C6191",
    placeholder: "#8D9DC3",
    modalBoxShadow: "#33333514",
    errorText: "#CF1C00",
    succesColor: "#0F8739",
    infoColor: "#01509E",
    tableTextColor: "#38476B",
    textColor: "#242E45",
    tableRowHoverColor: "#01509E",
    tableRowHoverBgColor: "#F2F4FA",
    themeColor: "#242E45",
    btnDisableBg: "#B3BED7",
    boxShadow: "#3333350F",
    inProgress: "#F68524",
    borderColorHeader: "#E6EBFA",
    greyBg: "#d3d3d3",
    black: "#000000",
    transparent: "transparent",
    loaderBorder: "#f3f3f3",
    deleteCount: '#ffa500',
    tableBorderColor: "#e9ebec",
    datepickerBg: "#364888",
    tableHeadBg: "#F3F6F9",
    vidOverlay: "#00000090",
    dynamicStatusBg: "#eaeaea",
    dynamicStatusText: "#6f6f6f",
    dynamicStatusBorder: "#b0b0b0",
    dynamicStatusFill: "#6f6f6f",
    todoStatusBg: "#ebf5ff",
    todoStatusText: "#1f7eeb",
    bookedStatusBg: "#fff1e3",
    bookedStatusText: "#fd7e14",
    soldStatusBg: "#eaf9e6",
    soldStatusText: "#4d8f3a",
    onHoldStatusBg: "#ffeeeb",
    onHoldStatusText: "#db5436",
    pendingStatusBg: "#fbf4dd",
    pendingStatusText: "#a37f08",
    inProgressStatusBg: "#eee7fc",
    inProgressStatusText: "#7038db",
    readOnlyStatusBg: "#fff9db",
    readOnlyStatusColor: "#a37f08",
    readWriteStatusBg: "#e6f7ff",
    readWriteStatusColor: "#0056b3",
    manageStatusBg: "#e6f9e6",
    manageStatusColor: "#007a33",
    headerTextColor: "#161C29",
    boxShadowEmail: "#e7e7e7",
    dateActiveColor: "#ffdc2826",
    cardBorderColor: "#242E4517",
   sideTabActiveColor:"#383f57",
   kanbanCardBg:"#f4f7ff",
   themeTextColor:"#79788e",
   borderLanding:"#EDEDED",
   playButtonBg:"#FFFFFF80",
   layerBgOne:"#ffffff05",
   layerBgTwo:"#ffffffdb",
   featureBoxBg:"#04252f45",
   themeLightBg:"#F8F8F8",
   errorColor:"#CF1C00",
   themeTextColorLight:"#525252",
   themeTextColorDark:"#060B13",
   themeTextColorN:"#363D4F",
   dashboardThemeTextColor:"#383838",
   tableHeaderTextColor:"#7C7C7C",
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "Inter,sans-serif",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "Inter,sans-serif",
      },
    }),
  },
};
